<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-9">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Status" >
                                <select class="form-control" :disabled="this.$attrs.friendlyCode=='RECPOS'" size="large" v-model="inputStatus">
                                    <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Format" >
                                <select class="form-control" size="large" v-model="inputFormat">
                                    <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <br>
                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                </download-excel>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: 'P',
                statusOptions: [
                    {key: 'P', value: 'Posted'},
                    {key: 'V', value: 'Voided'}
                ],
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'}
                ],
                inputFormat: 1,
                inputSortBy: 'terminal_id',
                sortOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                ],
                transOptions: [
                    {key: "RELPOS", value: "POS Sales"},
                    {key: "OROPOS", value: "POS Reservations"},
                    {key: "RECPOS", value: "POS Returns"},
                ],
                inputSite: [],
                site_type: "ho",
                showSortInfo: 'asc',
                
                checkedDetailFields: ["product_id","trans_id" ,"stock_no", "barcode", "product_name", "quantity"],
                checkedHeaderFields: ["id", "document_date", "posted_at", "origin_document_id", "origin_document_date", "status"],
                
                siteOptions: [],
                birSalesReports: [],
                JsonData: []
            }
        },
        mounted: async function () {
            var component_x = this;
            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            if(this.$attrs.friendlyCode=='RECPOS'){
                this.inputStatus = "R"
                this.statusOptions.push({key: 'R', value: 'Return'})
            }else {
                this.inputStatus = "P"
                this.statusOptions = [{key: 'P', value: 'Posted'},{key: 'V', value: 'Voided'}]
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let grandTotal = 0;

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null, "BXI-File");

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks"]
                
                var siteSpecific = get_request;
                let reportLogo = document.getElementById('reportLogo');

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }
                    
                    let headers = [];
                    let header_detail = [];
                    let simpleplus = 0
                    let spanplus = 0
                    if( this.inputFormat == 2 ) {
                        simpleplus = 5
                        spanplus = 1
                    }
                    header_detail.push( 
                        {content: 'Terminal', styles: {halign: 'left', valign: 'center'}},
                        {content: 'Date', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Trans #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'SI #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Customer', colSpan: 2 + spanplus, styles: {halign: 'center', valign: 'center'}},
                        {content: 'References', colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Remarks', colSpan: 3 + spanplus, styles: {halign: 'center', valign: 'center'}}
                        )

                    headers = [header_detail]
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                
                                if(grouper == 'start'){
                                    let h_detail = [
                                        {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                        {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 1, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.remark + "").replace("null", ""), colSpan: 3 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, h_detail))
                                    let cashier_detail = [
                                        {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, cashier_detail))
                                    let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.trans_id){
                                        let h_detail = [
                                            {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 1, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.remark + "").replace("null", ""), colSpan: 3 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, h_detail))
                                        let cashier_detail = [
                                            {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, cashier_detail))
                                        let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.trans_id

                                    let detail = [
                                        reportLine.product_id,
                                        reportLine.barcode,
                                        reportLine.product_name,
                                        this.convertToCurrency(Number(reportLine.quantity)),
                                        this.convertToCurrency(Number(reportLine.discount_total_amount)),
                                        this.convertToCurrency(Number(reportLine.original_price)),
                                        this.convertToCurrency(Number(reportLine.price)),
                                        this.convertToCurrency(Number(reportLine.subtotal / reportLine.quantity)),
                                        this.convertToCurrency(Number(reportLine.price * reportLine.quantity)),
                                        this.convertToCurrency(Number(reportLine.cost)),
                                        this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)),
                                    ]

                                let markup_display = 0
                                let markup_percent_display = 0
                                if(this.inputFormat == '2'){
                        
                                    markup_display = Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)

                                    if( Number(reportLine.cost * reportLine.quantity) != 0)
                                        markup_percent_display = (markup_display / Number(reportLine.cost * reportLine.quantity)) * 100
                                    else 
                                        markup_percent_display = Number(0)
                                    
                                    detail.push(
                                        this.convertToCurrency(Number(markup_display)),
                                        this.convertToCurrency(Number(markup_percent_display))
                                    )     
                                }

                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.price * reportLine.quantity)
                                sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_disc += Number(reportLine.discount_total_amount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.price)
                                sub_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.price * reportLine.quantity)
                                grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                grand_total_disc += Number(reportLine.discount_total_amount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.price)
                                grand_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.convertToCurrency(Number(sub_total_cost)), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                        ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, ['', '', 'Grand Total :', this.convertToCurrency(Number(grand_total_qty)), '', '', '', '', this.convertToCurrency(Number(grand_total_amount)), '', this.convertToCurrency(Number(grand_total_cost)), ((this.inputFormat == '2') ? this.convertToCurrency(Number(grand_total_markup)) : '' )
                                            ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.trans_id
                                    next_grouper = this.birSalesReports[i+1].trans_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.convertToCurrency(Number(sub_total_cost)), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                            ]));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,trans_val + " Journal By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        
                        doc.text(15,25,"For the Period of " + from_date + " to " + to_date)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 40},
                            2: {cellWidth: 60},
                            3: {cellWidth: 25 - simpleplus},
                            4: {cellWidth: 25 - simpleplus},
                            5: {cellWidth: 25 - simpleplus},
                            6: {cellWidth: 25 - simpleplus},
                            7: {cellWidth: 25 - simpleplus},
                            8: {cellWidth: 25 - simpleplus},
                            9: {cellWidth: 25 - simpleplus},
                            10: {cellWidth: 25 - simpleplus},
                        }

                        if (this.inputFormat == '2') {
                          colStyles = {
                            ...colStyles,
                            11: {cellWidth: 18},
                            12: {cellWidth: 18}
                          }
                        }
                        
                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });   
                    }
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    // reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal By " + group_text, 340, 200, x+1, siteSpecific.length)

                    let pageCount = doc.internal.getNumberOfPages();
                    let design_x = 340
                    let design_y =  205
                    for(let i = 1 ; i <= pageCount; i++) { 
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal By " + group_text, design_x, design_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let report_from_date = this.inputDate[0].format('YYYY-MM-DD');
                let report_to_date = this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&order_status=' + this.inputOrderStatus, null, "BXI-File");
                
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    return
                }
                let siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let headers = ['Terminal',' Date', 'Transaction Type', 'Subsegment', 'Site', 'Cashier', 'Food Server', ' Trans #',' SI #',' Customer',' References',' Remarks',' Product Code',' Barcode',' Description',' Quantity',' Discount',' SRP',' Net Price',' Average Price',' Total Amt',' Cost',' Total Cost',' MarkUp',' MarkUp%'];
                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(reportLine.barcode == null){
                                    reportLine.barcode = ''
                                }

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let markup_display = 0
                                let markup_percent_display = 0
                                
                                markup_display = Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)

                                if( Number(reportLine.cost * reportLine.quantity) != 0)
                                    markup_percent_display = (markup_display / Number(reportLine.cost * reportLine.quantity)) * 100
                                else 
                                    markup_percent_display = Number(0)

                                let detail = [
                                    String(reportLine.terminal_name),
                                    moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm A'),
                                    String(reportLine.transaction_type),
                                    String(reportLine.sub_segment),
                                    String(reportLine.site_name),
                                    String(reportLine.cashier),
                                    String(reportLine.cashier),
                                    String(reportLine.trans_id),
                                    String(reportLine.invoice_no),
                                    String(reportLine.customer_name),
                                    (reportLine.reference_code1 + "").replace("null", ""),
                                    (reportLine.remark + "").replace("null", ""),
                                    String(reportLine.product_id),
                                    String(reportLine.barcode),
                                    String(reportLine.product_name),
                                    this.convertToCurrency(Number(reportLine.quantity)),
                                    this.convertToCurrency(Number(reportLine.discount_total_amount)),
                                    this.convertToCurrency(Number(reportLine.original_price)),
                                    this.convertToCurrency(Number(reportLine.price)),
                                    this.convertToCurrency(Number(reportLine.subtotal / reportLine.quantity)),
                                    this.convertToCurrency(Number(reportLine.price * reportLine.quantity)),
                                    this.convertToCurrency(Number(reportLine.cost)),
                                    this.convertToCurrency(Number(reportLine.cost * reportLine.quantity)),
                                    this.convertToCurrency(Number(markup_display)),
                                    this.convertToCurrency(Number(markup_percent_display))
                                ]
                                // sub_total_qty += Number(reportLine.quantity)
                                // sub_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                // grand_total_qty += Number(reportLine.quantity)
                                // grand_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_disc += Number(reportLine.discount_total_amount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.price)
                                sub_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                grand_total_disc += Number(reportLine.discount_total_amount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.price)
                                grand_total_ave_price += Number(reportLine.subtotal) / Number(reportLine.quantity)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Subtotal : ', Number(sub_total_qty), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.convertToCurrency(Number(sub_total_cost)), this.convertToCurrency(Number(sub_total_markup))
                                    ]));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Grand total : ', Number(grand_total_qty), '', '', '', '', this.convertToCurrency(Number(grand_total_amount)), '', this.convertToCurrency(Number(grand_total_cost)), this.convertToCurrency(Number(grand_total_markup))
                                    ]));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ['', '', '', '', '', '', '', '', '', 'Subtotal : ', Number(sub_total_qty), '', '', '', '', this.convertToCurrency(Number(sub_total_amount)), '', this.convertToCurrency(Number(sub_total_cost)), this.convertToCurrency(Number(sub_total_markup))
                                        ]));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + report_from_date + " to " + report_to_date])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        },
    };
</script>

<style></style>